declare global {
  interface Window {
    ReactNativeWebView?: { postMessage: (message: string) => void };
  }
}

/** True when the PWA is running inside the React Native app's WebView. */
export const isInNativeApp = (): boolean => !!window.ReactNativeWebView;

/**
 * Opens invoice HTML for print / save-as-PDF.
 * - Browser: opens a new tab and triggers the print dialog.
 * - React Native WebView: window.open / blob URLs / window.print don't work there,
 *   so the HTML is posted to the native app, which handles print/PDF itself.
 * Returns false if nothing could be opened.
 */
export const printHtml = (htmlContent: string, fileName = "invoice"): boolean => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({ type: "PRINT_HTML", html: htmlContent, fileName })
    );
    return true;
  }

  const blob = new Blob([htmlContent], { type: "text/html" });
  const url = URL.createObjectURL(blob);
  const win = window.open(url, "_blank");
  if (win) {
    win.onload = () => {
      win.print();
      URL.revokeObjectURL(url);
    };
    return true;
  }

  // Popup blocked: fall back to downloading the HTML file
  const a = document.createElement("a");
  a.href = url;
  a.download = `${fileName}.html`;
  a.click();
  URL.revokeObjectURL(url);
  return true;
};
